import { LAYOUT_CONFIG } from "@circle-react-uikit/CircleAIAppShell/Layout/defaults";
import { useDesktopShellEngine } from "@circle-react-uikit/CircleAIAppShell/Layout/desktopShellEngineContext";
import { FlexHandle } from "@circle-react-uikit/CircleAIAppShell/Layout/Resizable/FlexHandle";
import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { DesktopShell } from "@circleco/compass/components/DesktopShell";

import { t } from "@/i18n-js/instance";

export const PanelResizeHandle = () => {
  const engine = useDesktopShellEngine();
  const isVisible = useCircleAIShellStore(s => s.isRightSidebarVisible);
  const width = useCircleAIShellStore(s => s.rightSidebarWidth);
  const onResize = useCircleAIShellStore(s => s.setRightSidebarWidth);

  const hiddenProps = {
    className: !isVisible ? "pointer-events-none cursor-default" : undefined,
    tabIndex: !isVisible ? -1 : undefined,
    "aria-hidden": !isVisible || undefined,
  };

  if (engine === "circle") {
    return (
      <FlexHandle
        aria-label={t("circle_ai_shell.resize_panel")}
        width={width}
        direction={-1}
        minWidth={LAYOUT_CONFIG.communityRightSidebar.minWidth}
        maxWidth={LAYOUT_CONFIG.communityRightSidebar.maxWidth}
        onResize={onResize}
        {...hiddenProps}
      />
    );
  }

  return (
    <DesktopShell.ResizeHandle
      aria-label={t("circle_ai_shell.resize_panel")}
      edge="start"
      width={width}
      minWidth={LAYOUT_CONFIG.communityRightSidebar.minWidth}
      maxWidth={LAYOUT_CONFIG.communityRightSidebar.maxWidth}
      onResize={onResize}
      {...hiddenProps}
    />
  );
};

PanelResizeHandle.displayName = "CircleAIAppShell.PanelResizeHandle";
